import { useState, useEffect } from 'react';

interface HeaderProps {
  onCtaClick: () => void;
}

export default function Header({ onCtaClick }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white shadow-md py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="/b2b" className="flex items-center gap-2 cursor-pointer">
          <img
            src="/assets/media/automat-logo.png"
            alt="Automat Logo"
            className={`h-9 w-auto object-contain transition-all duration-300 ${scrolled ? '' : 'brightness-0 invert'}`}
          />
        </a>

        {/* CTA */}
        <button
          onClick={onCtaClick}
          className={`whitespace-nowrap font-b2bbody font-semibold text-sm px-5 py-2.5 rounded-lg border-2 transition-all duration-200 cursor-pointer ${
            scrolled
              ? 'border-coral text-coral hover:bg-coral hover:text-white'
              : 'border-white text-white hover:bg-white hover:text-navy'
          }`}
        >
          Solicitar Demo
        </button>
      </div>
    </header>
  );
}
